const TeamMemberDialog = ({ member, onClose }) => {
  if (!member) return null;

  const handleBackdropClick = (e) => {
    // Only close if the user clicks on the backdrop itself, not the modal
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    // Backdrop
    <div
      onClick={handleBackdropClick}
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50 transition-opacity duration-300 ease-in-out"
    >
      {/* Dialog Panel */}
      <div className="bg-white rounded-lg shadow-xl w-full max-w-3xl mx-auto p-6 md:p-8 relative transform transition-all duration-300 ease-in-out scale-95 opacity-0 animate-modalshow">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-800 text-2xl font-bold"
          aria-label="Close dialog"
        >
          &times;
        </button>

        <div className="flex flex-col md:flex-row items-start gap-6">
          {/* Image Section */}
          <div className="flex justify-center w-full md:w-1/3 flex-shrink-0">
            <img
              src={member.imageSrc}
              alt={member.name}
              className="md:w-full w-3/4 h-[225px] md:h-[325px] object-cover rounded-lg shadow-md"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src =
                  "https://placehold.co/400x400/E2E8F0/4A5568?text=Image+Not+Found";
              }}
            />
          </div>

          {/* Text Content Section */}
          <div className="w-full md:w-2/3">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2">
              {member.name}
            </h2>
            <p className="text-md text-purple font-semibold mb-4">
              {member.title}
            </p>
            <p className="text-gray-600 text-sm leading-relaxed whitespace-pre-line">
              {member.description}
            </p>
          </div>
        </div>
      </div>

      {/* Modal animation keyframes */}
      <style jsx global>{`
        @keyframes modalshow {
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
        .animate-modalshow {
          animation: modalshow 0.3s forwards;
        }
      `}</style>
    </div>
  );
};

export default TeamMemberDialog;
